import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoaderService } from './services/loader/loader.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  constructor(public loader: LoaderService){}

  ngOnInit(): void{
  }
}
